import { format, getTime, parseISO } from 'date-fns';
import React, { useCallback, useMemo, useState } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { FaPlusCircle, FaTrashAlt } from 'react-icons/fa';
import { IAgenda } from '..';

import Agendamento from '../../../../components/Agendamento';
import Loading from '../../../../components/Loading';
import Modal from '../../../../components/Modal';
import PacoteAgendamento from '../../../../components/PacoteAgendamento';
import TratamentoAgendamento, {
  IReturnAgendamentoTratamento,
} from '../../../../components/TratamentoAgendamento';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import getResponseErrors from '../../../../utils/getResponseErrors';
import { IAgendamentoSelecionado } from '../../../AgendaBusca';

// import { Container } from './styles';

type IProps = {
  idTratamento: number;
  bloqueado: boolean;
  finalizado?: boolean;
  agendamentoTratamento?: number;
  perfilPacote?: number;
  agendamentosIniciais: IAgenda[];
  secoes: number;
  limite?: number;
  valor: number;
  validade?: Date;
};

const AgendamentosTratamento = ({
  idTratamento,
  bloqueado,
  finalizado,
  agendamentoTratamento,
  perfilPacote,
  agendamentosIniciais,
  secoes,
  limite,
  validade,
  valor,
}: IProps): JSX.Element => {
  const { addToast } = useToast();
  const [showAgenda, setShowAgenda] = useState(false);
  const [showAgendamento, setShowAgendamento] = useState(false);
  const [agendamentos, setAgendamentos] = useState<
    IReturnAgendamentoTratamento[]
  >(
    agendamentosIniciais
      .map(age => {
        return {
          AgeCodigo: age.AgeCodigo,
          AgeConfCodigo: age.AgeConfCodigo,
          AgeInicio: age.AgeInicio,
          AgeInicioFormatado: format(
            parseISO(age.AgeInicio.toString()),
            'dd/MM/yyyy HH:mm',
          ),
          updated_at: age.updated_at,
          valor: age.procedimentosValorCobrado.reduce((tot, item) => {
            return tot + Number(item.ProValor);
          }, 0),
        };
      })
      .sort(
        (a, b) =>
          getTime(parseISO(a.AgeInicio.toString())) -
          getTime(parseISO(b.AgeInicio.toString())),
      ),
  );

  const [loading, setLoading] = useState(false);

  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState<
    IAgendamentoSelecionado | undefined
  >(undefined);

  // useEffect(() => {
  //   async function loadDados(): Promise<void> {
  //     setLoading(true);
  //     try {
  //       const response = await api.get<ItratamentoAgendamento>(
  //         `/tratamento/${idTratamento}/agendamentos`,
  //       );
  //       setSecoes(response.data.secoes);
  //       const retornoAgendamentos: IReturnAgendamentoTratamento[] = response.data.agendamentosTratamento.map(
  //         age => {
  //           return {
  //             AgeCodigo: age.agenda.AgeCodigo,
  //             AgeConfCodigo: age.agenda.AgeConfCodigo,
  //             AgeInicio: age.agenda.AgeInicio,
  //             AgeInicioFormatado: format(
  //               parseISO(age.agenda.AgeInicio.toString()),
  //               'dd/MM/yyyy HH:mm',
  //             ),
  //             updated_at: age.agenda.updated_at,
  //           };
  //         },
  //       );
  //       setAgendamentos(
  //         retornoAgendamentos.sort(
  //           (a, b) =>
  //             getTime(parseISO(a.AgeInicio.toString())) -
  //             getTime(parseISO(b.AgeInicio.toString())),
  //         ),
  //       );
  //     } catch (error) {
  //       const mensagemErro = getResponseErrors(error);
  //       addToast({
  //         title: 'Não foi possível carregar agendamentos',
  //         type: 'error',
  //         description: mensagemErro,
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   if (idTratamento) loadDados();
  // }, [addToast, idTratamento]);

  const totalAgendado = useMemo(() => {
    return agendamentos.length;
  }, [agendamentos]);

  const handleFinalizouAgendamento = useCallback(
    (dados: IReturnAgendamentoTratamento) => {
      try {
        setAgendamentos(state => {
          return state
            ? state
                .concat(dados)
                .sort(
                  (a, b) =>
                    getTime(parseISO(a.AgeInicio.toString())) -
                    getTime(parseISO(b.AgeInicio.toString())),
                )
            : [dados];
        });
      } catch (error) {
        console.dir(error);
      }

      setShowAgenda(false);

      // setAgendamentoSelecionado(dados);
      // setShowAgendamento(true);
    },
    [],
  );

  const handleRemoverAgendamento = useCallback(
    async (AgeCodigo: number, updatedAt: Date) => {
      setLoading(true);
      try {
        await api.delete(
          `/agendamentos/tratamento/${AgeCodigo}?updated_at=${updatedAt}`,
        );

        setAgendamentos(state =>
          state.filter(age => age.AgeCodigo !== AgeCodigo),
        );
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar agendamentos',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <>
      {loading && <Loading />}
      {showAgenda && (
        <Modal
          show={showAgenda}
          titulo="Selecione os dados para agendamento"
          handleFecharModal={
            () => {
              setShowAgenda(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          {perfilPacote ? (
            <PacoteAgendamento
              orcamentoId={idTratamento}
              handleFechar={dados => handleFinalizouAgendamento(dados)}
              perfil={perfilPacote}
              agendamentos={agendamentos}
              limites={{ semanal: limite || 1, total: secoes }}
              validade={validade || new Date()}
            />
          ) : (
            <TratamentoAgendamento
              orcamentoId={idTratamento}
              handleFechar={dados => handleFinalizouAgendamento(dados)}
            />
          )}
        </Modal>
      )}

      {showAgendamento && agendamentoSelecionado && (
        <Modal
          show={showAgendamento}
          titulo="Agendamento"
          handleFecharModal={
            () => {
              setAgendamentoSelecionado(undefined);
              setShowAgendamento(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <Agendamento
            agendaId={agendamentoSelecionado.AgeConfCodigo}
            perfilId={undefined}
            data={undefined}
            AgeCodigo={agendamentoSelecionado.AgeCodigo}
            handleFecharAgendamento={() => {
              setShowAgendamento(false);
            }}
          />
        </Modal>
      )}
      <Row className={`${!bloqueado ? 'd-none' : ''}`}>
        <Col>
          <div className="d-flex justify-content-between">
            <b style={{ marginBottom: '4px' }}>Agendamentos</b>
            <b>{agendamentos?.length || 0}</b>
            <Button
              type="button"
              size="sm"
              variant="outline-info"
              onClick={() => setShowAgenda(true)}
              disabled={totalAgendado >= secoes}
            >
              <FaPlusCircle />
            </Button>
          </div>
          <br />
          <div>
            {agendamentos && agendamentos.length > 0 && (
              <Table
                className="table table-hover table-sm"
                id="GrdProcedimentos"
                style={{ borderWidth: '0px', marginTop: '-2px' }}
              >
                <tbody>
                  <tr className="bg-light" style={{ fontSize: 'Small' }}>
                    <th scope="col">Data</th>
                    <th scope="col"> - </th>
                    <th scope="col"> - </th>
                  </tr>
                  {agendamentos.map(age => (
                    <tr
                      key={`agendamento-${age.AgeCodigo}`}
                      style={{ fontSize: 'Small' }}
                    >
                      <td style={{ width: '100px' }}>
                        {age.AgeInicioFormatado}
                      </td>

                      <td className="w3-padding-0" style={{ width: '40px' }}>
                        <Button
                          className={`${finalizado ? 'd-none' : ''}`}
                          type="button"
                          variant="outline-success"
                          size="sm"
                          data-id={age.AgeCodigo}
                          onClick={() => {
                            setAgendamentoSelecionado({
                              AgeCodigo: age.AgeCodigo,
                              AgeConfCodigo: age.AgeConfCodigo,
                            });
                            setShowAgendamento(true);
                          }}
                        >
                          Ver Agendamento
                        </Button>
                      </td>
                      <td className="w3-padding-0" style={{ width: '40px' }}>
                        <Button
                          className={`${finalizado ? 'd-none' : ''}`}
                          type="button"
                          variant="outline-danger"
                          size="sm"
                          onClick={() => {
                            handleRemoverAgendamento(
                              age.AgeCodigo,
                              age.updated_at,
                            );
                          }}
                          disabled={loading || valor === age.valor}
                        >
                          <FaTrashAlt />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Col>
        <div />
      </Row>
      <Row className={`${!agendamentoTratamento ? 'd-none' : ''}`}>
        <Col>
          <div className="d-flex justify-content-between">
            <b style={{ marginBottom: '4px' }}>Agendamentos</b>
          </div>
          <br />
          <div>
            {agendamentos && agendamentos.length > 0 && (
              <Table
                className="table table-hover table-sm"
                id="GrdProcedimentos"
                style={{ borderWidth: '0px', marginTop: '-2px' }}
              >
                <tbody>
                  <tr className="bg-light">
                    <th scope="col">Data Hora</th>
                  </tr>
                  {agendamentos.map(age => (
                    <tr
                      key={`agendamento-${age.AgeCodigo}`}
                      style={{ fontSize: 'Small' }}
                    >
                      <td style={{ width: '100px' }}>
                        {age.AgeInicioFormatado}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        </Col>
        <div />
      </Row>
    </>
  );
};

export default AgendamentosTratamento;
